import { render, staticRenderFns } from "./ModalDetailIndication.vue?vue&type=template&id=c791a798&scoped=true"
import script from "./ModalDetailIndication.vue?vue&type=script&lang=js"
export * from "./ModalDetailIndication.vue?vue&type=script&lang=js"
import style0 from "./ModalDetailIndication.vue?vue&type=style&index=0&id=c791a798&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c791a798",
  null
  
)

export default component.exports